import { SyntheticEvent, useLayoutEffect, useState } from 'react'

import { useTenant } from 'shared/hooks'
import joinClassNames from 'utilities/joinClassNames'

import styles from './styles.module.scss'

const Visual = () => {
  const { tenant } = useTenant()

  const [welcomeImage, setWelcomeImage] = useState({
    src: '',
    isLoaded: false,
  })

  const loadImage = async () => {
    const loginImages = tenant?.ubiportal?.loginPage?.images

    const randomIndex = Math.floor(Math.random() * (loginImages?.length ?? 0))
    const url = loginImages?.[randomIndex] || 'default.png'
    setWelcomeImage({ src: url, isLoaded: false })
  }

  const handleFallback = async (
    event: SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    const { currentTarget } = event

    const fallbackIndex = Math.floor(Math.random() * 5) + 1
    const image = await import(`./assets/images/welcome-${fallbackIndex}.png`)

    currentTarget.src = image.default
  }

  useLayoutEffect(() => {
    loadImage()
  }, [tenant])

  return (
    <div className={styles.assets}>
      {welcomeImage.src && (
        <img
          className={joinClassNames(
            styles.image,
            welcomeImage.isLoaded && styles.imageLoaded,
          )}
          src={welcomeImage.src}
          alt="Bem vindo!"
          loading="eager"
          onLoad={() =>
            setWelcomeImage((prev) => ({ ...prev, isLoaded: true }))
          }
          onError={handleFallback}
        />
      )}
    </div>
  )
}

export default Visual
